import {TeamOwnershipView} from 'views/teams/TeamOwnershipView';

export const TeamOwnership = () => <TeamOwnershipView />;
